import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Translate from '../../../utils/Translate';
import Header from '../../commons/Header/Header';
import UpsertTravelCompanionContainer from './UpsertTravelCompanion/UpsertTravelCompanionContainer';
import './TravelCompanionPage.css';
import Alert from '../../commons/Alert/Alert';
import * as Pages from '../../../utils/Pages';

const TravelCompanionPage = withRouter(props => (
  <div className="eva-3-dashboard-aftersale TravelCompanionPage -eva-3-mb-xlg -eva-3-tc-gray-1 -eva-3-bc-gray-4">
    <Header
      name={Translate.message('Acompañantes de viaje')}
      page={Pages.TRAVEL_COMPANION}
    />
    <div className="eva-3-container -eva-3-bc-gray-4 -p-0 -p-md-2 -pb-md-4 -pl-md-5 -pr-md-5 -pt-4">
      <div className="dashboard-aftersale-results-container eva-3-row -no-gutter">
        {
          props.isMerging &&
          <div className="col -sm-12 -lg-8 -eva-3-mb-lg">
            <Alert type="warning" title={Translate.message('Estamos uniendo tus cuentas')}>
              {Translate.message('Mientras se realiza el proceso, no podrás modificar los datos de tu perfil. Por favor, regresá más tarde.')}
            </Alert>
          </div>
        }
        <div className="col -sm-12 -lg-8 subnav-profile">
          <UpsertTravelCompanionContainer
            travelCompanions={props.travelCompanions}
            hasError={props.clustersErrors.travelCompanions}
            isMerging={props.isMerging}
          />
        </div>
      </div>
    </div>
  </div>
));

TravelCompanionPage.propTypes = {
  travelCompanions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  clustersErrors: PropTypes.shape().isRequired,
  isMerging: PropTypes.bool.isRequired,
};

export default TravelCompanionPage;
